/* unplugin-vue-components disabled */import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapState } from 'vuex';
import Setting from '@/setting';
export default {
  name: 'iHeaderLogo',
  computed: _objectSpread(_objectSpread({}, mapState('admin/layout', ['isMobile', 'headerTheme'])), {}, {
    showLogo: function showLogo() {
      return Setting.layout.showLogo;
    },
    layout: function layout() {
      return Setting.layout;
    },
    style: function style() {
      if (Setting.layout.showSidebar && !this.showLogo) {
        return {
          width: '152px',
          paddingLeft: '10px'
        };
      }
    }
  })
};